import { render, staticRenderFns } from "./Fornecedores.vue?vue&type=template&id=559fb4fc&scoped=true"
import script from "./Fornecedores.vue?vue&type=script&lang=js"
export * from "./Fornecedores.vue?vue&type=script&lang=js"
import style0 from "./Fornecedores.vue?vue&type=style&index=0&id=559fb4fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559fb4fc",
  null
  
)

export default component.exports